import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import EntityList from "@/admin/components/EntityList";
import { fetchEntitiesQueryOptions } from "@/admin/services";
import Container from "@/components/containers/Container";
import { type ChildRouteContext } from "@/root";

export const Route = createFileRoute(
  "/admin/_panel/_settings/settings/entity/",
)({
  beforeLoad: ({ context }) =>
    ({
      title: () => context.t("Entities", { ns: "core.shared" }),
      crumb: [
        {
          label: context.t("Manage Entities", { ns: "core.shared" }),
        },
      ],
    }) satisfies ChildRouteContext,
  loader: (opts) =>
    opts.context.queryClient.prefetchQuery(fetchEntitiesQueryOptions()),
  component: Component,
});

function Component() {
  const { t } = useTranslation("core.shared");

  return (
    <Container
      title={t("Manage Entities")}
      description={t("Manage create and edit entities")}
    >
      <EntityList />
    </Container>
  );
}
